const LABELS = {
  app_android: "Dentro do app Android",
  app_instalado: "App instalado (atalho)",
  whatsapp: "Link do WhatsApp",
  celular: "Navegador do celular",
  desktop: "Computador",
  sem_dado: "Sem dado (antes do registro)",
};
const APP_LABELS = { futmob: "Futmob", futzap: "Futzap", weplay: "WePlay", pipoca: "Pipoca" };

export const SourceCard = ({ sources, apps }) => {
  const s = sources && typeof sources === "object" ? sources : {};
  const total = Object.values(s).reduce((a, b) => a + (Number(b) || 0), 0);
  const appList = Object.entries(apps && typeof apps === "object" ? apps : {});
  return (
    <div className="ad-card p-5" data-testid="admin-sources">
      <h2 className="ad-h2">Origem dos acessos</h2>
      <p className="text-xs text-[#9DB0A5] mt-1">Visitantes únicos no período</p>
      <ul className="mt-4 space-y-3">
        {Object.keys(LABELS).filter((k) => k !== "sem_dado" || s[k]).map((k) => {
          const n = Number(s[k]) || 0;
          const pct = total ? Math.round((n / total) * 100) : 0;
          return (
            <li key={k} data-testid={`admin-source-${k}`}>
              <div className="flex justify-between text-[13px] text-[#C9D6CE]">
                <span>{LABELS[k]}</span><span className="tabular-nums">{n} · {pct}%</span>
              </div>
              <div className="h-1.5 mt-1.5 rounded-full bg-[#22352B] overflow-hidden">
                <div className="h-full rounded-full bg-[#D4FF3A]" style={{ width: `${pct}%` }} />
              </div>
            </li>
          );
        })}
      </ul>
      {appList.length > 0 && (
        <p className="text-[12.5px] text-[#9DB0A5] mt-4" data-testid="admin-source-apps">
          Por app: {appList.map(([a, n]) => `${APP_LABELS[a] || a} ${n}`).join(" · ")}
        </p>
      )}
    </div>
  );
};
